/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Abbreviated invitation info for action responses
 * @export
 * @interface InvitationSummary
 */
export interface InvitationSummary {
    /**
     * 
     * @type {string}
     * @memberof InvitationSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationSummary
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof InvitationSummary
     */
    expiresAt?: number;
}

/**
 * Check if a given object implements the InvitationSummary interface.
 */
export function instanceOfInvitationSummary(value: object): value is InvitationSummary {
    return true;
}

export function InvitationSummaryFromJSON(json: any): InvitationSummary {
    return InvitationSummaryFromJSONTyped(json, false);
}

export function InvitationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
    };
}

export function InvitationSummaryToJSON(json: any): InvitationSummary {
    return InvitationSummaryToJSONTyped(json, false);
}

export function InvitationSummaryToJSONTyped(value?: InvitationSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'expiresAt': value['expiresAt'],
    };
}

